export const gate = {
  "/admin/api/key/index": "Access API Key Management",
  "/admin/content/author/index": "Access Author Management",
  "/admin/content/category/index": "Access Category Management",
  "/admin/content/comment/index": "Access Comment Management",
  "/admin/content/media/index": "Access Media Management",
  "/admin/content/post/index": "Access Post Management",
  "/admin/content/post/[category]/[id]/index": "Access Post Management",
  "/admin/content/tag/index": "Access Tag Management",
  "/admin/crm/kyc/applicant/analysis": "Access KYC Application Management",
  "/admin/crm/kyc/applicant/index": "Access KYC Application Management",
  "/admin/crm/kyc/applicant/[id]/index": "Access KYC Application Management",
  "/admin/crm/kyc/template/create": "Access KYC Template Management",
  "/admin/crm/kyc/template/index": "Access KYC Template Management",
  "/admin/crm/kyc/template/[id]/index": "Access KYC Template Management",
  "/admin/crm/permission/index": "Access Permission Management",
  "/admin/crm/role/index": "Access Role Management",
  "/admin/crm/support/ticket/analysis": "Access Support Ticket Management",
  "/admin/crm/support/ticket/index": "Access Support Ticket Management",
  "/admin/crm/support/ticket/[id]/index": "Access Support Ticket Management",
  "/admin/crm/user/analysis": "Access User Management",
  "/admin/crm/user/index": "Access User Management",
  "/admin/dashboard": "Access Admin Dashboard",
  "/admin/ext/affiliate/condition/index":
    "Access MLM Referral Condition Management",
  "/admin/ext/affiliate/referral/analysis": "Access MLM Referral Management",
  "/admin/ext/affiliate/referral/index": "Access MLM Referral Management",
  "/admin/ext/affiliate/reward/analysis":
    "Access MLM Referral Reward Management",
  "/admin/ext/affiliate/reward/index": "Access MLM Referral Reward Management",
  "/admin/ext/ai/investment/duration/index":
    "Access AI Investment Duration Management",
  "/admin/ext/ai/investment/log/analysis": "Access AI Investment Management",
  "/admin/ext/ai/investment/log/index": "Access AI Investment Management",
  "/admin/ext/ai/investment/plan/index": "Access AI Investment Plan Management",
  "/admin/ext/ecommerce/category/index": "Access Ecommerce Category Management",
  "/admin/ext/ecommerce/discount/index": "Access Ecommerce Discount Management",
  "/admin/ext/ecommerce/order/analysis": "Access Ecommerce Order Management",
  "/admin/ext/ecommerce/order/index": "Access Ecommerce Order Management",
  "/admin/ext/ecommerce/product/analysis":
    "Access Ecommerce Product Management",
  "/admin/ext/ecommerce/product/index": "Access Ecommerce Product Management",
  "/admin/ext/ecommerce/review/analysis": "Access Ecommerce Review Management",
  "/admin/ext/ecommerce/review/index": "Access Ecommerce Review Management",
  "/admin/ext/ecommerce/shipping/index": "Access Ecommerce Shipping Management",
  "/admin/ext/ecommerce/wishlist/index": "Access Ecommerce Wishlist Management",
  "/admin/ext/ecosystem/index": "Access Ecosystem Management",
  "/admin/ext/ecosystem/ledger/index":
    "Access Ecosystem Private Ledger Management",
  "/admin/ext/ecosystem/market/index": "Access Ecosystem Market Management",
  "/admin/ext/ecosystem/token/index": "Access Ecosystem Token Management",
  "/admin/ext/ecosystem/utxo/index": "Access Ecosystem UTXO Management",
  "/admin/ext/ecosystem/wallet/custodial/index":
    "Access Ecosystem Custodial Wallet Management",
  "/admin/ext/ecosystem/wallet/custodial/[id]/index":
    "Access Ecosystem Custodial Wallet Management",
  "/admin/ext/ecosystem/wallet/master/index":
    "Access Ecosystem Master Wallet Management",
  "/admin/ext/faq/category/index": "Access FAQ Category Management",
  "/admin/ext/faq/question/index": "Access FAQ Management",
  "/admin/ext/forex/account/analysis": "Access Forex Account Management",
  "/admin/ext/forex/account/index": "Access Forex Account Management",
  "/admin/ext/forex/duration/index": "Access Forex Duration Management",
  "/admin/ext/forex/investment/analysis": "Access Forex Investment Management",
  "/admin/ext/forex/investment/index": "Access Forex Investment Management",
  "/admin/ext/forex/plan/index": "Access Forex Plan Management",
  "/admin/ext/forex/signal/analysis": "Access Forex Signal Management",
  "/admin/ext/forex/signal/index": "Access Forex Signal Management",
  "/admin/ext/ico/allocation/index": "Access ICO Allocation Management",
  "/admin/ext/ico/contribution/analysis": "Access ICO Contribution Management",
  "/admin/ext/ico/contribution/index": "Access ICO Contribution Management",
  "/admin/ext/ico/phase/index": "Access ICO Phase Management",
  "/admin/ext/ico/project/index": "Access ICO Project Management",
  "/admin/ext/ico/token/analysis": "Access ICO Token Management",
  "/admin/ext/ico/token/index": "Access ICO Token Management",
  "/admin/ext/mailwizard/campaign/analysis":
    "Access Mailwizard Campaign Management",
  "/admin/ext/mailwizard/campaign/index":
    "Access Mailwizard Campaign Management",
  "/admin/ext/mailwizard/campaign/[id]/index":
    "Access Mailwizard Campaign Management",
  "/admin/ext/mailwizard/template/index":
    "Access Mailwizard Template Management",
  "/admin/ext/mailwizard/template/[id]/index":
    "Access Mailwizard Template Management",
  "/admin/ext/p2p/commission/analysis": "Access P2P Commission Management",
  "/admin/ext/p2p/commission/index": "Access P2P Commission Management",
  "/admin/ext/p2p/dispute/analysis": "Access P2P Dispute Management",
  "/admin/ext/p2p/dispute/index": "Access P2P Dispute Management",
  "/admin/ext/p2p/escrow/analysis": "Access P2P Escrow Management",
  "/admin/ext/p2p/escrow/index": "Access P2P Escrow Management",
  "/admin/ext/p2p/offer/analysis": "Access P2P Offer Management",
  "/admin/ext/p2p/offer/index": "Access P2P Offer Management",
  "/admin/ext/p2p/payment/method/analysis":
    "Access P2P Payment Method Management",
  "/admin/ext/p2p/payment/method/index": "Access P2P Payment Method Management",
  "/admin/ext/p2p/review/index": "Access P2P Review Management",
  "/admin/ext/p2p/trade/analysis": "Access P2P Trade Management",
  "/admin/ext/p2p/trade/index": "Access P2P Trade Management",
  "/admin/ext/p2p/trade/[id]/index": "Access P2P Trade Management",
  "/admin/ext/staking/duration/index": "Access Staking Duration Management",
  "/admin/ext/staking/log/analysis": "Access Staking Management",
  "/admin/ext/staking/log/index": "Access Staking Management",
  "/admin/ext/staking/pool/analysis": "Access Staking Pool Management",
  "/admin/ext/staking/pool/index": "Access Staking Pool Management",
  "/admin/finance/currency/fiat/index": "Access Fiat Currency Management",
  "/admin/finance/currency/spot/index": "Access Spot Currency Management",
  "/admin/finance/deposit/gateway/index": "Access Deposit Gateway Management",
  "/admin/finance/deposit/method/index": "Access Deposit Method Management",
  "/admin/finance/exchange/balance/index": "Access Exchange Balance Management",
  "/admin/finance/exchange/fee/index": "Access Exchange Fee Management",
  "/admin/finance/exchange/index": "Access Exchange Provider Management",
  "/admin/finance/exchange/market/index": "Access Exchange Market Management",
  "/admin/finance/exchange/provider/[productId]/index":
    "Access Exchange Provider Management",
  "/admin/finance/exchange/provider/[productId]/license":
    "Access Exchange Provider Management",
  "/admin/finance/investment/duration/index":
    "Access Investment Duration Management",
  "/admin/finance/investment/history/analysis": "Access Investment Management",
  "/admin/finance/investment/history/index": "Access Investment Management",
  "/admin/finance/investment/plan/index": "Access Investment Plan Management",
  "/admin/finance/order/binary/analysis": "Access Binary Order Management",
  "/admin/finance/order/binary/index": "Access Binary Order Management",
  "/admin/finance/order/ecosystem/analysis":
    "Access Ecosystem Order Management",
  "/admin/finance/order/ecosystem/index": "Access Ecosystem Order Management",
  "/admin/finance/order/exchange/analysis": "Access Exchange Order Management",
  "/admin/finance/order/exchange/index": "Access Exchange Order Management",
  "/admin/finance/transaction/analysis": "Access Transaction Management",
  "/admin/finance/transaction/index": "Access Transaction Management",
  "/admin/finance/wallet/analysis": "Access Wallet Management",
  "/admin/finance/wallet/index": "Access Wallet Management",
  "/admin/finance/withdraw/method/index": "Access Withdrawal Method Management",
  "/admin/page/index": "Access Pages Management",
  "/admin/system/announcement/index": "Access Announcement Management",
  "/admin/system/cron/index": "Access Cron Job Management",
  "/admin/system/database/backup": "Access Database Backup Management",
  "/admin/system/database/migration": "Access Database Migration Management",
  "/admin/system/extension/index": "Access Extension Management",
  "/admin/system/extension/[productId]/index": "Access Extension Management",
  "/admin/system/log/index": "Access Log Monitor",
  "/admin/system/notification/template/index":
    "Access Notification Template Management",
  "/admin/system/notification/template/[id]/index":
    "Access Notification Template Management",
  "/admin/system/settings/index": "Access System Settings Management",
  "/admin/system/update": "Access System Update Management",
  "/admin/theme/index": "Access Frontend Builder",
};
